
import { getDisplayCouponInfo } from '@/api/displayCoupon/display-coupon';
import { CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import {
  clickRegister, getBannerConfig, getCouponInfo,
} from '../api/index';

type VisitType = 'couponlist' | 'stamplist' | 'displaycouponlist';

const VisitTypeConfig: Record<VisitType, string> = {
  couponlist: '1',
  stamplist: '2', // Tab 已下线但保留映射，供 StampList.vue 直接调 updateRedDot('stamplist')
  displaycouponlist: '3',
};

export const updateRedDot = (type: VisitType) => {
  if (type) {
    clickRegister({ visit_type: VisitTypeConfig[type] });
  }
};

const hasRedPoint = '1';

type PrizeTabItemInfo = { hasRedDot: boolean; count: number };

type PrizeTabInfo = {
  couponlist: PrizeTabItemInfo;
  displaycouponlist: PrizeTabItemInfo;
};

const getCouponPrizeInfo = async (): Promise<PrizeTabItemInfo> => {
  const bannerConfig = getBannerConfig();
  const couponInfo = await getCouponInfo({
    expire_days: bannerConfig.coupon_expire_days,
  });
  return {
    hasRedDot: couponInfo.red_point === hasRedPoint,
    count: parseInt(couponInfo.total_cnt, 10) || 0,
  };
};

const getDisplayCouponPrizeInfo = async (): Promise<PrizeTabItemInfo> => {
  const res = await getDisplayCouponInfo();
  return {
    hasRedDot: res.red_point === hasRedPoint,
    count: parseInt(res.total_cnt, 10) || 0,
  };
};

export async function getUserPrizeTabInfo(): Promise<PrizeTabInfo> {
  const [err, res] = await to(Promise.all([
    getCouponPrizeInfo(),
    getDisplayCouponPrizeInfo(),
  ]));
  if (err) {
    throw new CustomException(err, 'getRedDotFail', '优惠专区获取红点失败');
  }
  return {
    couponlist: res[0],
    displaycouponlist: res[1],
  };
}
